import { useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';
import { getActiveDomainAndTab } from '@/config/navigation';

interface CurrentModule {
    moduleTitle: string;
    modulePath: string;
    groupTitle: string;
}

/**
 * Auto-detect the current module being viewed based on URL pathname.
 * Matches against DUAL_AXIS_NAVIGATION config to find the best matching menu item.
 */
export function useCurrentModule(): CurrentModule {
    const location = useLocation();
    const pathname = location.pathname;
    const searchStr = location.search ? (typeof location.search === 'string' ? location.search : new URLSearchParams(location.search as any).toString()) : '';

    return useMemo(() => {
        const { activeDomain, activeTab } = getActiveDomainAndTab(pathname, searchStr ? `?${searchStr}` : '');

        return {
            moduleTitle: activeTab?.title || activeDomain.title,
            modulePath: activeTab?.href || activeDomain.defaultHref,
            groupTitle: activeDomain.title,
        };
    }, [pathname, searchStr]);
}
